import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importOverpaymentWithdrawalFlowContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "OverpaymentWithdrawalFlowContainer" */
                '@perpay-web/fintech/components/screens/WithdrawalFlow/OverpaymentWithdrawalFlowContainer'
            ),
    );
